import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, RouterLink } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Observable, Subscription, forkJoin} from 'rxjs';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { GenericLambdaReturn } from '../models/genericLamba';
import { PlantViewService, PlantType } from '../services/plant-view.service';
import { Router } from '@angular/router';
import { LocationInformationService } from '../services/location-information.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { LoadingService } from '../services/loading.service';
import { DateSelectionComponent } from '../date-selection/date-selection.component';
import { MatButton } from '@angular/material/button';
import { SaveAsCsvComponent } from '../save-as-csv/save-as-csv.component';
import { MatSort } from '@angular/material/sort';
import { NgClass, DecimalPipe } from '@angular/common';

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
    selector: 'app-plant-view',
    templateUrl: './plant-view.component.html',
    styleUrls: ['./plant-view.component.scss'],
    imports: [RouterLink, DateSelectionComponent, MatButton, SaveAsCsvComponent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgClass, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, DecimalPipe]
})
export class PlantViewComponent implements OnInit, OnDestroy {
  dataSource:MatTableDataSource<PlantType>
  mDataSource: PlantType[]
  subscription: Subscription;
  currentShift: string = "True";
  plantDataArr: any[];
  dateString: string;
  
  public fromDateString: string;
  public toDateString: string;
  public plant: string;
  public plantDisplay: string;

  fg_hdr: FormGroup = new FormGroup('');
  manualInput: boolean = false;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['site', 'minor', 'major', 'critical', 'acknowledged','total', 'score'];

  constructor(private service: PlantViewService, 
              private locationInformationService: LocationInformationService, 
              private router: Router, 
              private route: ActivatedRoute,
              private loadingService: LoadingService,
              private formBuilder: FormBuilder
              ){
  }
 
  ngOnInit(){
    this.plant = this.route.snapshot.paramMap.get('plant')
    this.plantDisplay = this.route.snapshot.paramMap.get('plantdisplay') ? this.route.snapshot.paramMap.get('plantdisplay') : this.plant;

    this.fetch();
    setTimeout(() => 
      {
      console.log(' after call to navitems ' )
      this.locationInformationService.changeLocation(true)
      this.locationInformationService.changePlantView(true)
      this.locationInformationService.changePlant(this.plant)
      this.locationInformationService.changeDetailsView(false)
      this.locationInformationService.changeSeverityView(false)
      }
    )

    this.dataSource = new MatTableDataSource<PlantType>();
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  fetch(){
    this.loadingService.show();
    let d: Observable<GenericLambdaReturn<PlantType[]>> =
      this.route.paramMap.pipe(
        switchMap((params:ParamMap) =>
        this.service.getPlantData(this.currentShift, this.fromDateString + ' 00:00:00', this.toDateString + ' 23:59:59.999', this.plant))
      );
    
      if (this.subscription) this.subscription.unsubscribe();

    this.subscription = d.subscribe({
      next:(next) => {
        this.dataSource.data=next.Body;
        this.mDataSource = next.Body;
        this.plantDataArr = next.Body;
        this.dateString = this.fromDateString + '-' + this.toDateString;
        this.loadingService.hide();
      },    
      error: (err) => {
        console.error(err);
        this.loadingService.hide(); // also hide on error
      }
    })
    
  }


  severityDataSelect(severityType: string, plant: string){
    this.router.navigate(['details', plant, {Severity: severityType}]);
  }

  onDateChange(e: any) {
    this.fromDateString = e.fromDate;
    this.toDateString = e.toDate;
    this.currentShift = e.currentShift;

    this.fetch();
  }
}
